module.exports = __webpack_public_path__ + "089a4e885450f41ac58f5472a3b2eea7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_variant2_white.svg
// module id = 12
// module chunks = 0